import React, {Component} from 'react';
import { observer, inject, Provider } from "mobx-react";
import { observable, makeObservable, action, reaction, toJS } from "mobx";
import axios from "../../utils/axios";
import {checkbox, custom, input} from "../../utils/linker";
import CommentItem from "./CommentItem";
import commentsStore from "../../stores/commentsStore";
import LazyImg from "../Helpers/LazyImg";
import Tooltip from "../Helpers/Tooltip";
import { NavLink } from "react-router-dom";
import Loading from "../Loading";
import qs from "qs";
import historyVars from "../../utils/historyVars";
import { withRouter } from 'react-router-dom';
import HTML from "../Helpers/HTML";

class LastComments extends Component {
  list={
    fetching:false,
    inited:false,
    data:{}
  };
  with_readed='0';
  category_id=null;
  selected_cats=[];

  constructor(props) {
    super(props);
    makeObservable(this,{
      list: observable,
      with_readed: observable,
      category_id: observable,
      selected_cats: observable,
    });

    this._unreactReaded=reaction(()=>{ return this.with_readed },()=>{
      this.loadComments();
    });
    this._unreactCategory=reaction(()=>{ return this.category_id },()=>{
      this.loadComments();
    });

    this._firstTime=true;
  }
  componentWillUnmount() {
    console.log('unmount!');
    this._unreactUrlToCats();
    this._unreactReaded();
    this._unreactCategory();
    this._unreactCatsToUrl();
  }
  loadComments(force=false) {
    const opts={ type:this.props.type || 'my', with_readed:this.with_readed, category_id:this.selected_cats };
    if(this.props.element_id) {
      opts.element_id=this.props.element_id;
    }
    if(!this.isAll() && opts.category_id) {
      delete opts.category_id;
    }
    if(this.props.category_id) {
      opts.category_id=this.props.category_id;
    }



    if(force || this._lastOpts!==JSON.stringify(opts)) {
      this._lastOpts=JSON.stringify(opts);
      this.props.commentsStore.loadLastComments(opts);
    }
  }
  componentDidMount() {
    this._unreactCatsToUrl=reaction(()=>{ return this.selected_cats.join('-'); },(selCats)=>{
      historyVars.appendVars({ cats:this.selected_cats.join('-') });
    });
    this._unreactUrlToCats=reaction(()=>{ return this.props.router.location.search },(search)=>{
      // if(this._firstTime) {
      console.log('url to cats');
      if(this.isAll()) {
        if (this._firstTime) {
          if (!search) {
            if(this.checkLoadFilter()) {
              return false;
            }
          }
        }
        this._firstTime = false;
        const ob = qs.parse(search, {ignoreQueryPrefix: true});
        if (ob.cats) {
          this.selected_cats = ob.cats.split('-').map((item) => {
            return parseInt(item);
          });
        } else {
          this.selected_cats = [];
        }
      }
      this.loadComments();

    },{ fireImmediately:true, delay:200 });
    // this.checkLoadFilter();
  }
  checkLoadFilter() {
    if(this.isAll()) {
      if (window.localStorage) {
        const loaded = window.localStorage.getItem('mas2_comments_cats');
        if (loaded) {
          const loadedArr = JSON.parse(loaded);
          if(loadedArr.length) {
            historyVars.appendVars({cats: loadedArr.join('-')});
            return true;
          }
          // search=loadedArr.join('-');
        }
      }
    }
    return false;
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.type !== prevProps.type) {
      if(!this.checkLoadFilter()) {
        this.loadComments();
      } else {
        if(this.isAll() == this.isAll(prevProps)) {
          this.loadComments();
        }
      }
    }
  }

  renderRoot(rootElement, zeroComment) {
    if(this.props.renderRootElement) {
      return this.props.renderRootElement(rootElement, zeroComment);
    }
    const imgMap={
      51:"property_big_picture",
      56:"property_BIG_PICTURE",
      62:"property_POST_AVATAR",
      74:"property_BIG_PICTURE",
      80:"property_BIG_PICTURE",
      54:"created_by_avatar",
    };
    if(!rootElement) {
      return (
        <div className="ofh rad4-tl rad4-tr bg-w1 solid1-bottom bo-w2">
          <div className="up12 margin">
            <div style={{width:50,height:50}}></div>

            <div className="cell s-auto s-middle">
              <div className="fs11 pbottom2 w5">{this.getCategoryName(zeroComment.category_id)}</div>
              Удалено
            </div>
          </div>
        </div>
      )
    }
    let name=rootElement.name;
    if(!name) {
      if(rootElement.category == 54) {
        name=rootElement.created_by_nick;
      } else {
        name=this.props.translateStore.t.lk.element_type_photo;
      }
    }
    return (
      <div className="ofh rad4-tl rad4-tr bg-w1 solid1-bottom bo-w2">
        <div className="up12 margin">
          {rootElement[imgMap[rootElement.category]]?(
            <div className="cell s-splice">
              <LazyImg src={`/autoresize/50x50xC${rootElement[imgMap[rootElement.category]]}`} className="db mw100" passProps={{ style:{width:50, height:50} }} />
            </div>
          ):(
            <div style={{width:50,height:50}}></div>
          )}
          <div className="cell s-auto s-middle">
            <div className="fs11 pbottom2 w5">{this.getCategoryName(rootElement.category)}</div>
            {rootElement.detail_url?(
              <a href={rootElement.detail_url}><HTML inline={true}>{name}</HTML></a>
            ):(
              <HTML>{name}</HTML>
            )}
          </div>
        </div>

      </div>
    )
  }
  getCategoryName(catId)
  {
    const t = this.props.translateStore.t.lk;

    const map={
      62: t.type_blog_ed,
      51: t.type_figure_ed,
      56: t.type_photos_ed,
      74: t.type_anime_ed,
      80: t.type_character_ed,
      54: t.type_profile_ed,
      52: t.type_news_ed,
    };

    return map[catId];
  }
  readComment(item, index, commentIndex) {
    axios.post(`/api/comments/read`,{ ids:item._id }).then((data)=>{
      if(data.data.answer) {
        this.props.commentsStore.list.data.items[index].items.splice(commentIndex,1);
        if(!this.props.commentsStore.list.data.items[index].items.length) {
          this.props.commentsStore.list.data.items.splice(index,1);
        }
      }
      if(this.props.afterCommentRead) {
        this.props.afterCommentRead();
      }
    });
  }
  readAll(items, index) {
    axios.post(`/api/comments/read`,{ ids: items.map((item)=>{ return item._id }) }).then((data)=>{
      if(data.data.answer) {
        this.props.commentsStore.list.data.items.splice(index,1);
      }
      if(this.props.afterCommentRead) {
        this.props.afterCommentRead();
      }
    });
  }
  getPermalink(comment, parent) {
    if(parent && parent.detail_url) {
      return parent.detail_url+`?${this.props.commentsStore.comment_url_var}=${comment._id}`;
    }
    return null;
  }
  renderComments() {
    if(this.props.commentsStore.list.fetching) {
      return (
        <Loading />
      )
    }
    if(this.props.commentsStore.list.inited) {
      if(this.props.commentsStore.list.data.items.length>0) {
        const comments=this.props.commentsStore.list.data.items.map((item,index)=>{
          /*if(!item.category_id || !this.props.commentsStore.list.data.root_elements[item.category_id][item.element_id]) {
            return null;
          }*/
          const rootElement=this.props.commentsStore.list.data.root_elements[item.category_id]?this.props.commentsStore.list.data.root_elements[item.category_id][item.element_id]:null;
          const comments=[];
          for(let i in item.items) {
            const cur=this.props.commentsStore.list.data.items[index].items[i];
            const par=this.props.commentsStore.list.data.parents?this.props.commentsStore.list.data.parents[cur.parent_id]:null;
            comments.push(
              <div className="up12 splice hov"  key={item.items[i]._id}>
                <div className="cell s-auto">
                  {par?(
                    <CommentItem getPermaLink={()=>{ return this.getPermalink(par, rootElement); }} {...custom(this.props.commentsStore.list.data.parents, cur.parent_id)} force_margin={0} disable_edit={true} disable_reply={true} mode={"last_comments"} />
                  ):null}
                  <CommentItem getPermaLink={()=>{ return this.getPermalink(cur, rootElement); }} onCommentPost={()=>{
                    this.props.commentsStore.list.data.items[index].items[i].answered=1;
                    if(this.props.afterCommentPost) {
                      this.props.afterCommentPost(this.props.commentsStore.list.data.items[index].items[i]);
                    }
                  }} {...custom(this.props.commentsStore.list.data.items[index].items, i)} disable_reply={this.props.commentsStore.list.data.items[index].items[i].answered || !rootElement} force_margin={par?20:0} mode={"last_comments"} />
                  {this.props.commentsStore.list.data.items[index].items[i].answered?(
                    <div className="tar mbottom10"><span className="padd5 dib rad4 bg-w5 w1 fs11">{this.props.translateStore.t.lk.already_answered}</span></div>
                  ):null}
                </div>
                {this.isReadButtonNeed()?(
                  <div className="cell s-splice pleft20 op-hov">
                    <div className="rad200 bg-w3 w2 tc padd5 pointer" onClick={()=>{ this.readComment(item.items[i], index, i); }}>
                      <div title={this.props.translateStore.t.lk.mark_as_readed} className="mdi mdi-check lh10 fs32"></div>
                    </div>
                  </div>
                ):null}
              </div>
              )
          }
          if(comments.length) {
            return (
              <div className="" key={index}>
                <div className="up12 splice hov mbottom10">
                  <div className="cell s-auto">
                    {this.renderRoot(rootElement, item.items[0])}
                  </div>
                  {this.isReadButtonNeed()?(
                    <div className="cell s-splice pleft20 op-hov">
                      <div className="rad200 bg-w3 w2 tc padd5 pointer">
                        <div title={this.props.translateStore.t.lk.mark_block_as_readed} className="mdi mdi-check-all lh10 fs32" onClick={()=>{ this.readAll(item.items, index); }}></div>
                      </div>
                    </div>
                  ):null}
                </div>
                <div className="pleft20">
                  {comments}
                </div>
              </div>

            )
          } else {
            return false;
          }
        });

        return (
          <div>
            {comments}
          </div>
        )
      } else {
        const rest=(
          <div className="padd20 bg-w1 rad4 solid1 bo-w2 tac">
            <div className="mdi mdi-campfire w4 lh10" style={{fontSize:72}}></div>
            <div className="ptop20 fs24 font1">
              {this.props.translateStore.t.lk.all_readed_1}
            </div>
            <div className="fs14 ptop10">
              {this.props.translateStore.t.lk.all_readed_2}
            </div>
          </div>
        );
        if(this.props.renderRootElement) {
          return (
            <div>
              {this.props.renderRootElement(null,null)}
              <div className="pleft20 ptop10">
                {rest}
              </div>
            </div>
          )

        }
        return rest;
      }
    }
    return null;
  }
  isReadButtonNeed() {
    if(this.props.type == "all" || this.props.type == "your") {
      return false;
    } else {
      return this.with_readed == '0';
    }
  }
  saveCats() {
    const sel_csts=toJS(this.selected_cats);
    if(window.localStorage) {
      localStorage.setItem('mas2_comments_cats',JSON.stringify(sel_csts))
    }

  }
  toggleCat(cat) {
    if(!cat) {
      this.selected_cats=[];
    } else {
      const index = this.selected_cats.indexOf(cat);
      if (index > -1) {
        this.selected_cats.splice(index, 1);
      } else {
        this.selected_cats.push(cat);
      }
    }
  }
  isAll(props=null) {
    if(!props) {
      props=this.props;
    }
    return props.type == "all" || props.type == "your";
  }
  renderFilter() {
    const t = this.props.translateStore.t.lk;

    const checkboxes=[
      {category_id: 0, name: t.type_all },
      {category_id: 62, name: t.type_blog },
      {category_id: 51, name: t.type_figure },
      {category_id: 56, name: t.type_photo },
      {category_id: 74, name: t.type_anime },
      {category_id: 80, name: t.type_character },
      {category_id: 54, name: t.type_profile },
      {category_id: 52, name: t.type_news },
    ];

    if(this.isAll()) {
      return (
        <div className="up12 splice">
          <div className="cell s-auto s-middle">
            {checkboxes.map((item)=>{
              let isSelected=this.selected_cats.indexOf(item.category_id)>-1?true:false;
              if(!item.category_id && !this.selected_cats.length) {
                isSelected=true;
              }
              return (
                <span className={`fs14 hpadd10 mright5 vpadd5 pointer ${isSelected?'bg-pc1 w1':''}`} onClick={()=>{ this.toggleCat(item.category_id); }}>
                  <span className={`${isSelected?'':'dashed1-bottom'}`}>
                    {item.name}
                  </span>
                </span>
              )
            })}
          </div>
          <div className="cell s-shrink s-middle">
            <span onClick={()=>{ this.saveCats(); }} className="btn2 small"><span>Сохранить</span></span>
          </div>
        </div>
      )
    } else {
      return (
        <label>
          <input type="checkbox" {...checkbox(this, 'with_readed')} /><span></span><span className="dib vam">Включая прочитанные</span>
        </label>
      )
    }
  }
  render() {
    if(this.props.disable_wrapper) {
      return this.renderComments();
    }
    if(this.props.commentsStore.standalone) {
      return (
        <div className="up12 margin">
          <div className="cell s-12">
            {this.props.disable_type_switch?null:(
              <div className="ptop20">
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/last_comments/my/">{this.props.translateStore.t.lk.LAST_COMMENTS_FOR_ME}</NavLink>
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/last_comments/spy/">{this.props.translateStore.t.lk.LAST_COMMENTS_SPYING}</NavLink>
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/last_comments/follow/">{this.props.translateStore.t.lk.LAST_COMMENTS_FOLLOW}</NavLink>
                <NavLink className="fs14 padd5 mright10 dib" activeClassName="bg-pc1" activeStyle={{color:'#ffffff'}} to="/last_comments/your/">{this.props.translateStore.t.lk.LAST_COMMENTS_YOUR}</NavLink>
              </div>
            )}
          </div>
          <div className="cell s-auto">
            <h1>{this.props.translateStore.t.lk.LAST_COMMENTS}</h1>
          </div>
          <div className={`cell pbottom15 ${this.isAll()?'s-12':'s-shrink'} s-end wsnw`}>
            {this.renderFilter()}
          </div>
          <div className="cell s-12">
            {this.renderComments()}
          </div>
        </div>
      )
    } else {
      return (
        <div className="max padding">
          <div className="up12 splice">
            <div className="cell s-auto">
              <div className="up12 margin">
                <div className="cell s-auto">
                  <h1>{this.props.translateStore.t.lk.LAST_COMMENTS}</h1>
                </div>
                <div className={`cell pbottom15 ${this.isAll()?'s-12':'s-shrink'} s-end wsnw`}>
                  {this.renderFilter()}
                </div>
              </div>

              {this.renderComments()}
            </div>
          </div>
        </div>
      )
    }
  }
}

export default withRouter(inject("commentsStore","translateStore","router")(observer(LastComments)));